import { useState } from "react";
import { Card, List } from "antd";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import ModelDetail from "./ModelDetail";
import envConfig from "../config.json";
import { useTheme } from "./ThemeContext";
import {Colors} from './utils';
/**
 * Component to manage the content of the model list
 */
const ListContent = (props) => {
  const { instance } = useMsal();
  const { fetchModels, sas, selectedPlant, plantName } = props;

  const [showDetail, setShowDetail] = useState(false);
  const [title, setTitle] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [gltfUrl, setGltfUrl] = useState("");
  const [model, setModel] = useState([]);
  const [assetId, setAssetId] = useState("");
  const [curVer, setCurVer] = useState();
  const [verLength, setVerLength] = useState(0);
  const [multipleVersion, setMultipleVersion] = useState(false);
  const { theme } = useTheme();

  /**
   * Function to handle the show modal
   * @param {*} item selected Item/model
   */
  const showModal = (item) => {
    setShowDetail(true);
    setTitle(item.title);
    setAssetId(item.assetId);
    getModelDetail(item.assetId);
  };
  const deleteProgress = () => {
    setShowProgress(true);
  };
  const deleteDone = () => {
    setShowProgress(false);
  };
  /**
   * fuction to handle close the model
   */
  const closeModel = () => {
    setShowDetail(false);
    setGltfUrl("");
  };
  /**
   * function used to get the model details
   * @param {*} assetId the model asset id
   */
  const getModelDetail = (assetId) => {
    const msalToken = localStorage.getItem("msal.accesstoken");
    setShowProgress(true);
    const getConfig = {
      headers: { Authorization: `Bearer ${msalToken}` },
    };
    axios
      .get(`${envConfig.aotmwapi}/api/3d-cms/content/${assetId}`, getConfig)
      .then((response) => {
        setShowProgress(false);
        const res = response.data;
        setModel(res);
        setVerLength(res.versions.length);
        let lastElement = res.versions[res.versions.length - 1];
        setCurVer(lastElement);
        lastElement = lastElement.assets.filter(function (x) {
          return x.format === "glb" || x.format === "gltf";
        });
        if (lastElement.length !== 0) {
          setGltfUrl(lastElement[0].url);
        }
        if (res.versions.length !== 1) {
          const isValid = res.versions.every((item) => item.isMapped === false && item.isPlantMapped === false && item.isPOIMapped === false);
          setMultipleVersion(isValid);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("checkRole");
          const logoutRequest = {
            postLogoutRedirectUri: envConfig.redirectUri,
          };
          instance.logoutRedirect(logoutRequest);
        }
        console.error(err.message);
      });
  };
  const handleError = (event) => {
    event.target.onerror = null; // Prevents looping
    event.target.src = "/aotLogo.png";
  };

  return (
    <>
      <List
        className="listPadding"
        grid={{
          gutter: 16,
          column: 4,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
        }}
        dataSource={props.models}
        renderItem={(item) => (
          <List.Item className={`listItemBackground-${theme}`}>
            <Card
              onClick={() => showModal(item)}
              title={item.title}
              headStyle={{
                backgroundColor: theme === Colors.dark ? Colors.darkBackground :Colors.lightBackground,
                border: 0,
                color: theme === Colors.dark ? Colors.darkText : Colors.darkBody
              }}
              bodyStyle={{
                padding: 8,
                borderTop: "0px solid #202633",
              }}
            >
              <div className="imageframe">
                <img
                  alt="example"
                  src={item.thumbnailUrl || "/aotLogo.png"}
                  onError={ handleError }
                  className="preview"
                />
              </div>
            </Card>
          </List.Item>
        )}
      />
      <ModelDetail
        showDetail={showDetail}
        title={title}
        model={model}
        showProgress={showProgress}
        gltfUrl={gltfUrl}
        assetId={assetId}
        curVer={curVer}
        closeModel={closeModel}
        fetch3DCEModels={fetchModels}
        page="aot"
        sas={sas}
        verLength={verLength}
        selectedPlant={selectedPlant}
        plantName={plantName}
        multipleVersion={multipleVersion}
        deleteProgress={deleteProgress}
        deleteDone={deleteDone}
      ></ModelDetail>
    </>
  );
};
export default ListContent;
